import axios from "axios";
import { IRefreshTokenResponse } from "../types/auth.types";
import { getRefreshToken } from "../utils/storage.utils";

/**
 * Refresh token — uses raw axios (not axiosInstance) to bypass the response
 * interceptor entirely. Reads API_BASE_URL from the build-time env var so
 * this module does NOT import axiosInstance, avoiding a circular dependency.
 */
export const refreshToken = async (): Promise<IRefreshTokenResponse> => {
  const token = await getRefreshToken();

  if (token == null) {
    return Promise.reject(new Error("No refresh token available"));
  }

  const baseURL = (process.env.API_BASE_URL ?? "").replace(/\/$/, "");
  const response = await axios.post<IRefreshTokenResponse>(
    `${baseURL}/auth/refresh`,
    { refresh_token: token },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
